import { render, staticRenderFns } from "./personality_test.vue?vue&type=template&id=0d9c9bca&scoped=true"
import script from "./personality_test.vue?vue&type=script&lang=js"
export * from "./personality_test.vue?vue&type=script&lang=js"
import style0 from "./personality_test.vue?vue&type=style&index=0&id=0d9c9bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c9bca",
  null
  
)

export default component.exports